import React, { useState } from "react";
import { usuariosAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../utils/Tools";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useGlobal from "../../utils/useGlobal";

const Login = (props) => {
  // const [nombreUsuario, setNombreUsuario] = useState('');
  // const [password, setPassword] = useState('');
  const [usuario, setUsuarioLocal] = useState({ nombreUsuario: "", password: "" });
  const { setUsuario } = useGlobal();
  
  const handleLoginClick = (e) => {
    e.preventDefault();

    if (usuario.nombreUsuario !== "" && usuario.password !== "") {
      const data = JSON.stringify({ accion: "login", usuario });
      usuariosAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          sessionStorage.setItem("usuario", respuesta.datos.usuario);
          sessionStorage.setItem("tipoCliente", respuesta.datos.tipoCliente);
          sessionStorage.setItem("token", respuesta.jwt);
          //sessionStorage.setItem("documento", respuesta.documento);
          //sessionStorage.setItem("nombreYapellido", respuesta.nombreYapellido);
          //usuario.usuario = nombreUsuario;
          //usuario.tipoCliente = tipoCliente;
          setUsuario({
            usuario: respuesta.datos.usuario,
            tipoCliente: respuesta.datos.tipoCliente,
          });
          if (props.onLoginClickEnCompra) {
            // props.onLoginClick();
            props.onLoginClickEnCompra(true);
          } else {
            // props.onLoginClick();
            props.history.goBack();
          }
        }
      });
    } else {
      toast.info("Debe completar todos los campos", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleLoginChange = (e) => {
    setUsuarioLocal((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
    // this.setState({[e.target.name]:e.target.value});
  };

  return (
    <div>
      <div className="title">
        <h2>Log-in</h2>
        <p>Ingrese o reg&iacute;strese para continuar con su compra.</p>
        <hr />
      </div>
      <form className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 login">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="material-icons">email</i>
            </span>
          </div>
          <input
            type="email"
            name="nombreUsuario"
            id="mail"
            placeholder="Ingrese su mail"
            onChange={handleLoginChange}
          />
        </div>
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="material-icons">lock</i>
            </span>
          </div>
          <input
            type="password"
            name="password"
            id="password"
            onChange={handleLoginChange}
            placeholder="Ingrese su contrase&ntilde;a"
          />
        </div>
        <div className="input-group">
          <div className="options">
            <Link to={"/registracion"}>Crear nuevo usuario</Link>
            <Link to={"/recuperar-password"}>
              ¿Olvid&oacute; su contrase&ntilde;a?
            </Link>
          </div>
          <input
            className=""
            type="submit"
            value="ingresar"
            onClick={handleLoginClick}
          />
        </div>
      </form>
      {props.mostrarToastContainer && <ToastContainer />}
    </div>
  );
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/index.js